import { UrlMatcher, UrlMatchResult, UrlSegment } from '@angular/router';

export function entityDetailUrlMatcher(entityName: string, ...additionalSegments: string[]): UrlMatcher {
   const expectedSegmentCount = 2 + additionalSegments.length;
   return (segments: UrlSegment[]): UrlMatchResult | null => {
      if (segments.length >= expectedSegmentCount) {
         const [entitySegment, idSegment, ...rest] = segments;
         if (entitySegment.path !== entityName) {
            return null;
         }

         const num = +idSegment.path;
         if (isNaN(num) || !Number.isInteger(num)) {
            return null;
         }

         for (let i = 0; i < additionalSegments.length; i++) {
            const expectedSegment = additionalSegments[i];
            const actualSegment = rest[i];
            if (!actualSegment || expectedSegment !== actualSegment.path) {
               return null;
            }
         }

         const posParams: Record<string, UrlSegment> = {
            id: idSegment,
         };

         const tabSegment = segments[expectedSegmentCount];
         if (tabSegment) {
            posParams['tab'] = tabSegment;
         }

         return {
            consumed: segments.slice(0, expectedSegmentCount + (tabSegment ? 1 : 0)),
            posParams,
         };
      }
      return null;
   };
}
